import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";
import MUIDataTable, {
  MUIDataTableColumnDef,
  MUIDataTableOptions,
} from "mui-datatables";
import IRouterComponentProps from "../../../models/IRouterComponentProps";
import AuthService from "../../auth/AuthService";
import {
  productTextSearch,
  productUrl,
  annualAuctionProduct,
  getAnnualBidInfo,
  annualBidUrl,
  annualMyLatestBidsForUser,
  productDownload,
  annualMyRecentBidsForUser,
} from "../../../common/config/app.endpoints";
import LoadingSpinner from "../../../common/elements/LoadingSpinner";
import { oAuth } from "../../../routes/basic/BasicAppRouter";
import {
  StyledButton,
  StyledModal,
} from "../../../common/materials/GenericStyleComponent";
import { MuiThemeProvider, useTheme } from "@material-ui/core/styles";
import update from "immutability-helper";
import moment from "moment";
import Countdown from "react-countdown";
import EllipsisText from "../../../common/elements/EllipsisText";
import {
  createTheme,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@material-ui/core";
import copy from "copy-to-clipboard";
import {
  faEdit,
  faHeart,
  faShareSquare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { openJewelleryCertificateLinkPopup } from "../../../common/GenericFunctions";

import AlertReadOnlyUser from "../../../common/elements/AlertReadOnlyUser";
import {
  convertedValue,
  convertedbuyItNowValue,
  getMyLatestStoredBids,
  getReturnMyLatestStoredBid,
} from "../../products/preview/TenderGenericFunc";
import JewelleryFilter from "../../products/preview/JewelleryFilter";
import {
  StyledBuyitNow,
  StyledHeaderContainer,
  StyledIconImg,
  StyledSelectAllButtonHeader,
  StyledTextWrapper,
} from "./DiamondProductStyle";
import ProductGridDataChildComponent from "./mobileUi/ProductGridDataChildComponent";
import BlockUserModal from "../../products/BlockUser/BlockUserModal";
import JwlProductGridDataParent from "./mobileUi/JwlProductGridDataParent";
import ProductBiddingUi from "./biddingUi/ProductBiddingUi";
import JwlProductMyBids from "./JwlProductMyBids";
import PubSub from "pubsub-js";
import AnnualBidPopup from "../../products/preview/bidPopupComponent/AnnualBidPopup";
import ApiTimeout from "../../../modules/ApiTimeout";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { AppDispatch } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  resetAnnualCurrentApiStartCount,
  resetAnnualItemPerPage,
  resetAnnualJewelleryCurrentApiStartCount,
  resetAnnualJewelleryItemPerPage,
  reSetJwlIsMybids,
  selectAnnualJewelleryCurrentApiStartCount,
  selectAnnualJewelleryItemPerPage,
  setAnnualJewelleryCurrentApiStartCount,
  setAnnualJewelleryItemPerPage,
} from "../../../redux/slice/commanPagination/commanPaginationSlice";
import { RootState } from "../../../redux/reducer";
import JewelleryAnnualActionPage from "../../core-grid/grid-actions/JewelleryAnnualActionPage";
import AnnualTabJwl from "../../products/preview/AnnualTabJwl";
import {
  resetGridProductAllProductIndexes,
  resetjewelleryAllProductSelectAll,
  resetJwlIsGridView,
  selectJwlAuctionData,
  selectJwlGridView,
  setGridProductAllProductIndexes,
  setjewelleryAllProductSelectAll,
  setJwlIsGridView,
} from "../../../redux/slice/annual/commanAnnualSlice";
import BasicSearchBox from "../../core-grid/grid-actions/BasicSearchBox";
import {
  StyledBoxContent,
  StyledDropDown,
} from "../../../common/materials/GenericStyleMuitable";
import BuyItNowconfirmation from "./BuyItNow/BuyItNowconfirmation";
import ViewBuyItNowWinnerModal from "./modal/ViewBuyItNowWinnerModal";
import BulkBidFloatingIcon from "./biddingUi/BulkBidFloatingIcon";
const faEditProps = faEdit as IconProp;
const faHeartProps = faHeart as IconProp;
const faShareSquareProps = faShareSquare as IconProp;

const StyledLayoutGridMain = styled(Grid)`
  .icon {
    width: 2.8em;
    height: 2.8em;
  }
  .MuiIconButton-edgeEnd {
    display: contents !important;
    transition: width 5s !important;
  }
  .MuiAccordionSummary-root {
    min-height: 10px !important;
    transition: width 4s !important;
  }
  .MuiPaper-root {
    box-shadow: none !important;
  }
  .AccordionHeader {
    width: 100%;
    transition: width 1s;

    @keyframes fadeMe {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    ${(props) => props.theme.breakpoints.down("md")} {
      width: 100%;
    }
    ${(props) => props.theme.breakpoints.between("xs", "md")} {
      top: 46px;
      width: 100% !important;
    }
  }
  ${(props) => props.theme.breakpoints.between("xs", "md")} {
    padding: 10px 10px;
  }
`;

const StyledLayoutGrid = styled(Grid)`
  .MuiPaper-root {
    width: 100%;
  }
  .MuiTableCell-root {
    padding: 7px;
    border: 1px solid lightgray;
  }

  .MuiToolbar-regular {
    min-height: 0px;
  }
  .MuiTableCell-head {
    background: ${(props) => props.theme.colors.base.buttonGradientFirstColor};
    color: white;
    text-align: center;
    font-weight: 700;
    border: 1px solid lightgray;
  }
  .MUIDataTableHeadCell {
    justify-content: center;
  }
  .MuiTableCell-root {
    text-align: center;
  }

  .MuiTableCell-head {
    text-wrap: nowrap;
  }

  .MuiTableCell-head .MuiButton-root {
    color: white;
    text-align: center;
    font-weight: 700;
  }

  ${(props) => props.theme.breakpoints.between("xs", "md")} {
    padding: 10px 10px;
  }
  .linkCss {
    text-decoration: underline;
    color: blue;
    cursor: pointer;
  }

  .buttonGray {
    background: ${(props) => props.theme.colors.base.gray};
  }

  .MuiTableCell-footer {
    padding: 2px;
    font-size: 0.2em;
    height: 40px;
  }
`;
const StyledBtnContainer = styled.div`
  text-align: center;
`;

const StyledCoreDataGridContainer = styled(Grid)``;

const StyledActionBarContainer = styled(Grid)`
  border-radius: 5px;
  justify-content: end;
  padding: 5px;
  box-shadow: 2px 0px 5px 2px ${(props) => props.theme.colors.base.lightGrey};
  &:focus {
    outline: none;
  }
  grid-gap: 5px;
`;

export const StyledButtonGray = styled.button`
  color: ${(props) => props.theme.colors.base.black};
  border: none;
  font-size: 0.8em;
  padding: 0.6em;
  margin: 0.3em;
  border-radius: 5px;
  background: ${(props) => props.theme.colors.base.gray};
  border: 1px solid ${(props) => props.theme.colors.base.white};
`;

const StyledButtonHeader = styled.button`
  color: ${(props) => props.theme.colors.base.white};
  font-size: 1em;
  padding: 0.4em;
  margin: 0.3em;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.base.white};
  background: #2660ad;
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.base.textColor};
    cursor: pointer;
  }

  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    font-size: 0.8em;
  }
`;

const StyledTabLayout = styled(Grid)``;

const StyledContent = styled(Grid)`
  text-align: center;
`;
const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 5px;
`;

export interface IProductViewProps extends IRouterComponentProps {
  setShowAlertMessage: any;
  setOpenToast: any;
  setAlertType: any;
}

let data: any = {};
let totalElement: number = 0;
let page: number = 0;

let payload: any = {};
let startCount: number = 0;
let endCount: number = 20;
let rowSelectedData: any;
let updatedRowData: any;
let updateRowIndex: any;
let auctionProductResult: any;
let seconds: any = "";

let filter: any = [];
let filteredJewelleryValues: any = "";
let body: any = [];
let auctionName: string = "";

let details: any;
let length: any;

let auctionId: any;
let jwlAuctionUserId: any;
let joinedAnnualAuctions: any = [];
let bidProductIndex: any = [];

const columnIndexes = {
  serialNo: 0,
  perId: 1,
  auctionUserId: 2,
  buyItNow: 3,
  productCode: 6,
  lab: 7,
  certificate: 8,
  description: 9,
  currency: 10,
  remarks: 11,
  notes: 12,
  peicePerCt: 13,
  myLatestBids: 14,
  currentBidPrice: 15,
  noOfBids: 16,
  rowColor: 17,
  exchangeRate: 18,
  noOfBidders: 21,
  currentBidValue: 17,
  hieghestBidValue: 18,
  watched: 22,
  sellerAuctionUserId: 23,
  previousHighestBidder: 25,
  productStartDate: 26,
  productExtended: 27,
  holdPreviousBidder: 28,
};

let date: string | string[] = "";
let auctionDate: any;
let indexsForBulkBidItems: any = [];
let myLatestBidForProduct: any = [];
let isReadOnlyUser: any;
let isAuctionUserId: boolean;
let joinedAuctions: any = [];
const initialState = {
  mouseX: null,
  mouseY: null,
};

let timeVal: any = 2000;
const JewelleryProductAuction = (props: IProductViewProps) => {
  let { setShowAlertMessage, setOpenToast, setAlertType } = props;

  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MUIDataTableSelectCell: {
          fixedHeader: {
            background: "white",
          },
          fixedLeft: {
            background: "white",
          },
        },
      },
    });

  const [auctionProducts, setAuctionProducts] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingNoProduct, setIsLoadingNoProduct] = useState<boolean>(true);
  const [isShowSearchBox, setShowSearchBox] = useState<boolean>(true);
  const [apiTimeout, setApiTimeout] = useState<boolean>(false);
  const [onAction, setOnAction] = useState<boolean>(false);
  const [isFiltersOpen, setIsFiltersOpen] = useState<boolean>(false);
  const [userBlock, setUserBlock] = useState<boolean>(false);
  const [textSearchArray, setTextSearchArray] = useState([]);
  const [optionValue, setOptionValue] = useState("");
  const [showTenderSlider, setshowTenderSlider] = useState<boolean>(false);
  const [uiBoxView, setUiBoxView] = useState<boolean>(false);
  const [showBulkBidPopup, setShowBulkBidPopup] = useState<boolean>(false);
  const [showBulkBidButton, setShowBulkBidButton] = useState<boolean>(false);
  const [isDataRefresh, setIsDataRefresh] = useState<boolean>(false);
  const [openReadOnlyUserToast, setOpenReadOnlyUserToast] =
    useState<boolean>(false);
  const [isSort, setIsSort] = useState<boolean>(false);
  const [isTableExpanded, setIsTableExpanded] = useState<boolean>(false);
  const [currentProductId, setCurrentProductId] = useState<string>("");
  const [productdate, setProductStartDate] = useState<string>("");
  const [isExportDisable, setIsExportDisable] = useState<boolean>(false);
  const [productDetails, setProductDetails] = useState("");
  const [buyItWinnerPop, setBuyItWinnerPop] = useState(false);
  const [mouseState, setMouseState] = React.useState<{
    mouseX: null | number;
    mouseY: null | number;
  }>(initialState);
  const [tabValue, setTabValue] = useState({
    allProducts: true,
    myBids: false,
  });
  const [isSelected, setIsSelected] = useState<boolean>(false);
  const [isBuyItNowModal, setIsBuyItNowModal] = useState(false);
  const [currentProductData, setCurrentProductData] = useState(null);

  let isMypage: boolean = false;
  const Auth = new AuthService();
  let history = useHistory();
  const { t } = props;
  const eventSource: any = useRef<any>();
  const watchedItemArr: any = useRef<any>();
  const countAnnualRef = useRef(0);
  const secondTryAnnualRef = useRef(0);
  const jwlItemPerPageRef = useRef(20);
  const selectJwlPageUseRef = useRef(0);
  const maxRetryCount = 2;
  const countRef = useRef(0);
  const maxCallApiCount = 1;

  const [shouldGetAllData, setShouldGetAllData] = useState(false);
  const dispatch: AppDispatch = useDispatch();

  const isGridView: any = useSelector((state: RootState) =>
    selectJwlGridView(state)
  );

  const annualData: any = useSelector((state: RootState) =>
    selectJwlAuctionData(state)
  );
  useEffect(() => {
    setIsLoading(true);
    dispatch(resetGridProductAllProductIndexes());
    dispatch(resetjewelleryAllProductSelectAll());
    // localStorage.removeItem("dropDownFilterVal");
    localStorage.removeItem("annualdropDownFilterVal");
    localStorage.removeItem("filteredAnnualAucValues");
    localStorage.removeItem("filteredValues");
    //data table api calling
    localStorage.removeItem("filteredParcelValues");
    isReadOnlyUser = localStorage.getItem("isReadOnlyUser");
    isReadOnlyUser = JSON.parse(isReadOnlyUser);

    joinedAuctions = localStorage.getItem("joinedAnnualAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);

    dispatch(resetAnnualItemPerPage());
    dispatch(resetAnnualCurrentApiStartCount());
    dispatch(reSetJwlIsMybids());

    if (joinedAuctions !== null || joinedAuctions?.length !== undefined) {
      joinedAuctions?.filter((items: any, index: number) => {
        if (items.category === "Jewellery") {
          auctionId = items.perId;
          jwlAuctionUserId = items.auctionUserId;
          auctionDate = items.startDate;
        }
      });
    } else {
      auctionId = annualData.perId;
      jwlAuctionUserId = annualData.auctionUserId;
      auctionDate = annualData.startDate;
    }

    if (auctionId !== undefined) {
      //Event source Connection to the server
      getAllUpdatedData();
      //mylatestBids for sparate auction
      getMyLatestBids(auctionId);
    } else {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
        setApiTimeout(false);
      }, 2000);
    }

    PubSub.subscribe("updateProduct", (msg: any, data: any) => {
      if (data.auctionId === auctionId) {
        if (
          data.message === "SCHEDULED_EXTENDED_PRODUCTS" ||
          data.message === "ANNUAL_EXTENDED_PRODUCT_MARK_END_MESSAGE" ||
          data.message === "ANNUAL_EXTENDED_PRODUCT_MARKED_END_MESSAGE" ||
          data.message === "NEW_ANNUAL_PRODUCTS_AVAILABLE" ||
          data.message === "ANNUAL_PRODUCTS_UPDATES_AVAILABLE"
        ) {
          setIsLoading(true);
          getTendorAucProducts(auctionId, selectcurrentApiStartCountValue);
        } else if (data.message === "ANNUAL_PRODUCTS_SOLD") {
          setProductDetails(data.productDesc);
          setTimeout(() => {
            setIsLoading(true);
            setCurrentProductData(null);
            getTendorAucProducts(auctionId, selectcurrentApiStartCountValue);
            if (data.winnerId === jwlAuctionUserId) {
              // winner model
              setBuyItWinnerPop(true);
            }
          }, 2000);
        }
      }
    });

    return () => {
      if (eventSource.current !== undefined || eventSource.current !== null) {
        if (eventSource.current?.close !== undefined) {
          eventSource.current?.close();
        }
      }
      localStorage.removeItem("urlProductAuctionFromEmail");
      auctionName = "";
    };
  }, []);

  const selectcurrentApiStartCountValue: any = useSelector((state: RootState) =>
    selectAnnualJewelleryCurrentApiStartCount(state)
  );

  const selectItemPerPageValue: any = useSelector((state: RootState) =>
    selectAnnualJewelleryItemPerPage(state)
  );

  useEffect(() => {
    localStorage.setItem(
      "currentStart",
      JSON.stringify(selectcurrentApiStartCountValue * selectItemPerPageValue)
    );
    auctionId = annualData.perId;
    jwlAuctionUserId = annualData.auctionUserId;
    auctionDate = annualData.startDate;
    if (auctionId !== undefined) {
      getTendorAucProducts(auctionId, selectcurrentApiStartCountValue);
    }
  }, [selectItemPerPageValue, selectcurrentApiStartCountValue]);

  useEffect(() => {
    if (shouldGetAllData) {
      getAllUpdatedData();
      setShouldGetAllData(false);
    }
  }, [shouldGetAllData]);

  const getAllUpdatedData = () => {
    if (countRef.current < maxRetryCount) {
      eventSource.current = new EventSource(
        `${getAnnualBidInfo}?auctionId=${auctionId}`
      );
      eventSource.current.onmessage = (event: any) => {
        updatedRowData = JSON.parse(event.data);
        if (updatedRowData !== undefined) {
          if (updatedRowData.alive) {
            //This will listen only for events
          } else {
            if (auctionId === updatedRowData.auctionId) {
              updateRowIndex = auctionProductResult.findIndex(
                (product: any) => product.perId === updatedRowData.perId
              );
              const mapping: any = {};
              if (
                auctionProductResult !== undefined &&
                auctionProductResult.length > 0
              ) {
                auctionProductResult.map((items: any) => {
                  mapping[items.perId] = {
                    watched: items.watched,
                  };
                });
              }
              var updatedArr: any;
              if (updateRowIndex !== -1) {
                updatedArr = update(auctionProductResult, {
                  $splice: [[updateRowIndex, 1, updatedRowData]],
                });
              } else {
                updatedArr = auctionProductResult;
              }

              const arr = [...updatedArr];
              arr.map((items: any) => {
                if (watchedItemArr.current !== null) {
                  let watchedItemIndex = watchedItemArr.current.findIndex(
                    (product: any) => items.perId === product.productId
                  );
                  if (mapping[items.perId] !== undefined) {
                    if (watchedItemIndex !== -1) {
                      items.watched =
                        watchedItemArr.current[watchedItemIndex].watched;
                    } else {
                      items.watched = mapping[items.perId].watched;
                    }
                  }
                } else {
                  if (mapping[items.perId] !== undefined) {
                    items.watched = mapping[items.perId].watched;
                  }
                }
              });

              auctionProductResult = arr;
              setAuctionProducts(auctionProductResult);
              setShouldGetAllData(false);
            }
          }
        }
      };
      eventSource.current.onerror = (err: any) => {
        console.error("EventSource failed:", err);
        countRef.current = countRef.current + 1;
        setShouldGetAllData(true);
      };
    }
  };

  const getTendorAucProducts = (
    auctionId: number | string,
    currentPage: number,
    isLoadPreSelectedPage?: boolean
  ) => {
    setOpenToast(false);
    body = [];
    filteredJewelleryValues = localStorage.getItem("filteredJewelleryValues");
    filteredJewelleryValues = JSON.parse(filteredJewelleryValues);

    if (filteredJewelleryValues !== undefined) {
      if (
        filteredJewelleryValues === null ||
        filteredJewelleryValues.length === 0
      ) {
        filter = null;
      } else {
        filteredJewelleryValues.map((item: any, index: number) => {
          if (item.name === "auctionId") {
            filteredJewelleryValues.splice(index, 1);
          }
        });
        filter = filteredJewelleryValues;
      }
    }
    getBody(auctionId, currentPage, endCount, isLoadPreSelectedPage);
  };

  const getTendorAucProductsFirst = (
    auctionId: number | string,
    currentPage: number,
    isLoadPreSelectedPage?: boolean
  ) => {
    setOpenToast(false);
    body = [];
    filteredJewelleryValues = localStorage.getItem("filteredJewelleryValues");
    filteredJewelleryValues = JSON.parse(filteredJewelleryValues);

    if (filteredJewelleryValues !== undefined) {
      if (
        filteredJewelleryValues === null ||
        filteredJewelleryValues.length === 0
      ) {
        filter = null;
      } else {
        filteredJewelleryValues.map((item: any, index: number) => {
          if (item.name === "auctionId") {
            filteredJewelleryValues.splice(index, 1);
          }
        });
        filter = filteredJewelleryValues;
      }
    }

    setTimeout(() => {
      getBody(auctionId, currentPage, endCount, isLoadPreSelectedPage);
    }, timeVal);
    if (timeVal <= 15000) {
      timeVal = timeVal + 2000;
    } else {
      timeVal = 2000;
    }
  };

  const getBody = (
    auctionId: string | number,
    currentPage: number,
    endCount: number,
    isLoadPreSelectedPage?: boolean
  ) => {
    data = {};

    filteredJewelleryValues = localStorage.getItem("filteredJewelleryValues");
    filteredJewelleryValues = JSON.parse(filteredJewelleryValues);

    if (
      selectcurrentApiStartCountValue !== null &&
      selectcurrentApiStartCountValue !== 0
    ) {
      startCount = selectcurrentApiStartCountValue * selectItemPerPageValue;
    } else {
      startCount = 0;
    }

    if (
      selectcurrentApiStartCountValue != null &&
      selectcurrentApiStartCountValue !== 0
    ) {
      page = selectcurrentApiStartCountValue;
    } else {
      page = 0;
    }

    if (selectItemPerPageValue !== null) {
      let savedCount: any = selectItemPerPageValue;
      endCount = savedCount;
    } else {
      endCount = 20;
    }
    //handle drop downfilter value

    if (
      localStorage.getItem("dropDownFilterVal") !== undefined &&
      localStorage.getItem("dropDownFilterVal") !== null
    ) {
      var tempArr = localStorage.getItem("dropDownFilterVal");
      if (tempArr !== null) var dropDownValues = JSON.parse(tempArr);
      var property = dropDownValues[0].property;
      var direction = dropDownValues[0].direction;
    }

    if (
      filter === null &&
      (filteredJewelleryValues === null ||
        filteredJewelleryValues === undefined ||
        filteredJewelleryValues === "null" ||
        filteredJewelleryValues.length === 0)
    ) {
      payload = {
        page: {
          start: isLoadPreSelectedPage ? currentPage * 20 : startCount,
          count: selectItemPerPageValue,
          sort: {
            orders:
              property === "serialNo"
                ? [
                  {
                    property:
                      property !== null && property !== undefined
                        ? property
                        : "productEndDate",
                    direction:
                      direction !== null && direction !== undefined
                        ? direction
                        : "ASC",
                  },
                ]
                : [
                  {
                    property:
                      property !== null && property !== undefined
                        ? property
                        : "productEndDate",
                    direction:
                      direction !== null && direction !== undefined
                        ? direction
                        : "ASC",
                  },
                  {
                    property: "serialNo",
                    direction:
                      direction !== null && direction !== undefined
                        ? direction
                        : "ASC",
                  },
                ],
          },
        },
      };
    } else {
      body = filteredJewelleryValues ? filteredJewelleryValues : filter;
      body.map((item: any, index: number) => {
        if (item.name === "auctionId") {
          body.splice(index, 1);
        }
      });
      payload = {
        filters: {
          or: body,
          and: [
            {
              match: "exact",
              name: "parcelType",
              value: "Jewellery",
            },
          ],
        },
        page: {
          start: isLoadPreSelectedPage ? currentPage * 20 : startCount,
          count: selectItemPerPageValue,
          sort: {
            orders:
              property === "serialNo"
                ? [
                  {
                    property:
                      property !== null && property !== undefined
                        ? property
                        : "productEndDate",
                    direction:
                      direction !== null && direction !== undefined
                        ? direction
                        : "ASC",
                  },
                ]
                : [
                  {
                    property:
                      property !== null && property !== undefined
                        ? property
                        : "productEndDate",
                    direction:
                      direction !== null && direction !== undefined
                        ? direction
                        : "ASC",
                  },
                  {
                    property: "serialNo",
                    direction:
                      direction !== null && direction !== undefined
                        ? direction
                        : "ASC",
                  },
                ],
          },
        },
      };
    }

    let val = localStorage.getItem("optionValue");
    if (val !== "" && val !== "null" && val != null) {
      setOptionValue(val);
      payload = {
        filters: {
          and: [],
          or: [
            {
              match: "anywhere",
              name: "productDescription",
              value: val,
            },
            {
              match: "anywhere",
              name: "remarks",
              value: val,
            },
          ],
        },
        page: {
          start: isLoadPreSelectedPage ? currentPage * 20 : startCount,
          count: selectItemPerPageValue,
          sort: {
            orders:
              property === "serialNo"
                ? [
                  {
                    property:
                      property !== null && property !== undefined
                        ? property
                        : "productEndDate",
                    direction:
                      direction !== null && direction !== undefined
                        ? direction
                        : "ASC",
                  },
                ]
                : [
                  {
                    property:
                      property !== null && property !== undefined
                        ? property
                        : "productEndDate",
                    direction:
                      direction !== null && direction !== undefined
                        ? direction
                        : "ASC",
                  },
                  {
                    property: "serialNo",
                    direction:
                      direction !== null && direction !== undefined
                        ? direction
                        : "ASC",
                  },
                ],
          },
        },
      };
    }
    callApi(payload);
  };

  //Note: Get my All LatestBid using this Api

  const callApi = (payload: any) => {
    if (!oAuth()) {
      history.push("/");
    } else {
      setIsLoading(true);
      Auth.postRequest(
        `${annualAuctionProduct}?auctionType=Annual&category=Jewellery`,
        payload,
        (status: any, response: any) => {
          if (status === 200) {
            totalElement = response.totalElements;
            auctionProductResult = response.results;
            setAuctionProducts(response.results);
            setIsLoading(false);
            setIsLoadingNoProduct(false);
            countAnnualRef.current = 0;
            secondTryAnnualRef.current = 1;
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 404) {
            setIsLoading(false);
            setShowAlertMessage(`${t("common:invalidRequest")}`);
            setOnAction(false);
            setAlertType("error");
            setOpenToast(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setOnAction(false);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
          }
        }
      );
    }
  };

  const getMyLatestBids = (auctionId: string) => {
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.getRequest(
        `${annualMyLatestBidsForUser}?auctionId=${auctionId}`,
        (status: number, response: any) => {
          if (status === 200) {
            setIsLoading(false);
            myLatestBidForProduct = response;
            setIsLoadingNoProduct(false);
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage("Internal Server Error");
            setAlertType("error");
            setOpenToast(false);
          }
        }
      );
    }
  };
  const getMyRecentBids = (auctionId: string, productObj: any) => {
    if (!oAuth()) {
      history.push("/");
    } else {
      Auth.postRequest(
        `${annualMyRecentBidsForUser}?auctionId=${auctionId}`,
        productObj,
        (status: number, response: any) => {
          if (status === 200) {
            setIsLoading(false);
            let arrayModify = response;
            arrayModify.concat(
              myLatestBidForProduct.filter(
                (x: any) =>
                  !arrayModify.find((m: any) => m.productId === x.productId)
              )
            );
            setIsDataRefresh(!isDataRefresh);
            setIsLoadingNoProduct(false);
          }
        }
      );
    }
  };
  const handleBidClick = (tableData: any, indexVal: any) => {
    rowSelectedData = tableData;
    rowSelectedData = tableData;
    getProductsDetails(auctionProducts, indexVal);
    details = indexVal;
    setshowTenderSlider(true);
  };

  //rediract from bid now button of Jewellery product details page -------

  const renderAutomaticBidPopup = (data: any) => {
    const rediractProductId: any = localStorage.getItem(
      "currentJewelleryProductIdOfBidNow"
    );
    if (rediractProductId !== null) {
      const indexOfProduct = auctionProducts.findIndex(
        (item: any) => item.perId === rediractProductId
      );
      rowSelectedData = data;
      details = indexOfProduct;

      length = auctionProducts.length;
      if (details !== -1) {
        setshowTenderSlider(true);
      }
      localStorage.removeItem("currentJewelleryProductIdOfBidNow");
    }
  };

  const renderAutomaticBidPopupInMobile = (data: any) => {
    const rediractProductId: any = localStorage.getItem(
      "currentJewelleryProductIdOfBidNow"
    );
    if (rediractProductId !== null) {
      const indexOfProduct = auctionProducts.findIndex(
        (item: any) => item.perId === rediractProductId
      );
      rowSelectedData = data;
      length = auctionProducts.length;
      details = indexOfProduct;
      if (details !== -1) {
        setshowTenderSlider(true);
      }
      localStorage.removeItem("currentJewelleryProductIdOfBidNow");
    }
  };

  const getProductsDetails = (product: any, indexValue: any) => {
    length = auctionProducts.length;
    details = indexValue;
    return details;
  };

  //index of Mobile ui component
  const getBoxIndex = (boxIndex: any) => {
    length = auctionProducts.length;
    details = boxIndex;
    setshowTenderSlider(true);
  };

  const handleFilters = () => {
    setIsFiltersOpen(!isFiltersOpen);
    setShowSearchBox(!isShowSearchBox);
  };

  const textSearchListing = (value: String) => {
    payload = {
      filters: {
        or: [
          {
            match: "anywhere",
            name: "remarks",
            value: value,
          },
          {
            match: "anywhere",
            name: "productDescription",
            value: value,
          },
        ],
      },
    };

    if (value === "" || value.length === 1) {
      setTextSearchArray([]);
    } else {
      if (value.length > 1) {
        Auth.postRequest(
          productTextSearch,
          payload,
          (status: any, response: any) => {
            if (status === 200) {
              setTextSearchArray(response.results);
            }
          }
        );
      }
    }
  };

  const autoCompleteSearch = (val: any) => {
    //handle local storege
    localStorage.setItem("optionValue", val);
    getTendorAucProducts(auctionId, 0);
  };

  const getTableBodyHeight = () => {
    var h = window.innerHeight;
    let heightOfInnerTable: any;
    if (isTableExpanded) {
      heightOfInnerTable = h - 370;
    } else {
      heightOfInnerTable = h - 210;
    }
    if (auctionProducts.length > 2) {
      return `${heightOfInnerTable}px`;
    }
  };

  const options: MUIDataTableOptions = {
    filter: false,
    download: "false",
    print: "false",
    viewColumns: "false",
    count: totalElement,
    page: page,
    serverSide: true,
    search: false,
    rowsPerPage: selectItemPerPageValue,
    rowsPerPageOptions: [0],
    selectableRows: "multiple",
    selectableRowsHeader: true,
    selectableRowsOnClick: false,
    isRowSelectable: (dataIndex: any, selectedRows: any) => {
      const disableRowIndexsArray = getDisableRowIndex();
      return disableRowIndexsArray.includes(dataIndex) ? false : true;
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      return (
        <div className="mailIconDiv">
          <IconButton color="primary">
            <i className="zmdi zmdi-email"></i>
          </IconButton>
        </div>
      );
    },
    onChangePage: (currentPage: number) => {
      localStorage.setItem(
        "currentStart",
        JSON.stringify(currentPage * jwlItemPerPageRef.current)
      );
      dispatch(setAnnualJewelleryCurrentApiStartCount({ currentPage }));
    },
    onSearchChange: (searchTxt: any) => {
      //
    },
    setRowProps: (row: any, dataIndex: any, rowIndex: any) => {
      if (row[columnIndexes.previousHighestBidder] === undefined) {
        if (row[columnIndexes.holdPreviousBidder] === undefined) {
          if (row[columnIndexes.auctionUserId] !== jwlAuctionUserId) {
            return { style: { background: "white" } };
          } else {
            return { style: { background: row[columnIndexes.rowColor] } };
          }
        } else {
          if (jwlAuctionUserId === row[columnIndexes.holdPreviousBidder]) {
            return { style: { background: "#ffeb9c" } };
          } else {
            return { style: { background: row[columnIndexes.rowColor] } };
          }
        }
      } else {
        if (jwlAuctionUserId === row[columnIndexes.previousHighestBidder]) {
          return { style: { background: "#FBE4D5" } };
        } else {
          return { style: { background: row[columnIndexes.rowColor] } };
        }
      }
    },
    onColumnSortChange: (price: any, direction: any) => {
      let order = "";
      if (isSort === false) {
        order = "desc";
      } else {
        order = "asc";
      }
      setIsSort(!isSort);
      sort(price, order);
    },
    onRowSelectionChange: (
      currentRowsSelected: any,
      allRowsSelected: any,
      rowsSelected: any
    ) => {
      indexsForBulkBidItems = rowsSelected;
      setOpenToast(false);
      indexsForBulkBidItems.slice(0, 10).map((indexs: any) => {
        let {
          sellerAuctionUserId,
          previousHighestBidder,
          auctionUserId,
          holdPreviousBidder,
        } = auctionProducts[indexs];
        if (sellerAuctionUserId === auctionUserId) {
          return { ...options, isRowSelectable: "false" };
        } else if (previousHighestBidder !== undefined) {
          if (auctionUserId === previousHighestBidder) {
            return { ...options, isRowSelectable: "false" };
          }
        } else if (holdPreviousBidder !== undefined) {
          if (auctionUserId === holdPreviousBidder) {
            return { ...options, isRowSelectable: "false" };
          }
        } else if (jwlAuctionUserId === auctionUserId) {
          return { ...options, isRowSelectable: "false" };
        }
      });
      if (indexsForBulkBidItems.length >= 0) {
        setShowBulkBidButton(true);
      } else {
        setShowBulkBidButton(false);
      }
      if (indexsForBulkBidItems.length === 0) {
        setShowBulkBidButton(false);
      }
      if (indexsForBulkBidItems.length > 10) {
        setShowAlertMessage(
          `${t("common:Tender:validation:productSelection")}`
        );
        setAlertType("error");
        setOpenToast(true);
      }
    },
    tableBodyHeight: getTableBodyHeight(),
    textLabels: {
      body: {
        noMatch: isLoadingNoProduct
          ? "Loading data..."
          : `${t("common:preview:noProductFound")}`,
      },
    },
  };

  const onGridSelectionChange = (rowsSelected: any) => {
    indexsForBulkBidItems = rowsSelected;
    setOpenToast(false);
    if (indexsForBulkBidItems.length >= 0) {
      setShowBulkBidButton(true);
    } else {
      setShowBulkBidButton(false);
    }
    if (indexsForBulkBidItems.length === 0) {
      setShowBulkBidButton(false);
    }
    if (indexsForBulkBidItems.length > 10) {
      setShowAlertMessage(`${t("common:Tender:validation:productSelection")}`);
      setAlertType("error");
      setOpenToast(true);
    }
  };

  //bidding color of bidded section
  const boxColor = (items: any) => {
    const { rowColor, previousHighestBidder, holdPreviousBidder } = items;
    if (previousHighestBidder === undefined) {
      if (holdPreviousBidder === undefined) {
        if (jwlAuctionUserId !== items.auctionUserId) {
          return "white";
        } else {
          return rowColor;
        }
      } else {
        if (jwlAuctionUserId === holdPreviousBidder) {
          return "#ffeb9c";
        } else {
          return rowColor;
        }
      }
    } else {
      if (jwlAuctionUserId === previousHighestBidder) {
        return "#FBE4D5";
      } else {
        return rowColor;
      }
    }
  };

  const getDisableRowIndex = () => {
    return auctionProducts.map((items: any, index: number) => {
      if (isReadOnlyUser) {
        return index;
      } else {
        if (items.sellerAuctionUserId === jwlAuctionUserId) {
          return index;
        } else if (items.previousHighestBidder !== undefined) {
          if (jwlAuctionUserId === items.previousHighestBidder) {
            return index;
          }
        } else if (items.holdPreviousBidder !== undefined) {
          if (jwlAuctionUserId === items.holdPreviousBidder) {
            return index;
          }
        } else if (items.auctionUserId === jwlAuctionUserId) {
          return index;
        }
      }
    });
  };

  //server side sorting
  const filterSort = (price: any, direction: any) => {
    let order = "";
    if (direction === "asc") {
      order = "desc";
    } else {
      order = "asc";
    }
    sort(price, order);
  };

  const sort = (value: any, direction: any) => {
    sortData(value, direction);
  };

  //sorting
  const sortData = (values: any, direction: any) => {
    let tempArr: any = [{ property: values, direction: direction }];

    if (direction === "asc") {
      tempArr = [{ property: values, direction: "ASC" }];
      localStorage.setItem("dropDownFilterVal", JSON.stringify(tempArr));
    } else {
      tempArr = [{ property: values, direction: "DESC" }];
      localStorage.setItem("dropDownFilterVal", JSON.stringify(tempArr));
    }
    if (selectcurrentApiStartCountValue === 0) {
      getTendorAucProducts(auctionId, 0);
    } else {
      dispatch(resetAnnualJewelleryCurrentApiStartCount());
    }
    // getTendorAucProducts(auctionId, 0);
    selectJwlPageUseRef.current = 0;
    localStorage.removeItem("currentStart");
  };

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "serialNo",
      label: `${t("common:Tender:tableColumnNames:serialNo")}`,
      options: {
        filter: true,
        sort: true,
        display: true,
        setCellProps: () => ({
          style: { minWidth: "70px", maxWidth: "100px" },
        }),
      },
    },
    {
      name: "perId",
      label: "Product Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "auctionUserId",
      label: "Auction User Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "buyItNow",
      label: `${t("common:Tender:tableColumnNames:buyItNow")}`,
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          style: {
            background: "#E14843",
            color: "white",
            textAlign: "center",
          },
        }),
        setCellProps: () => ({
          style: { minWidth: "90px", maxWidth: "100px" },
        }),
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          let val: any = auctionProducts[rowIndex];
          return (
            <div>
              <span>
                {convertedbuyItNowValue(
                  val.currency,
                  val.buyItNow,
                  val.exchangeRates[0].rate
                )}
              </span>
              <StyledBtnContainer>
                {val.buyItNow === 0 ||
                  val.sellerAuctionUserId === jwlAuctionUserId ||
                  isReadOnlyUser ||
                  val.buyItNow < val.currentBidPrice ? (
                  <StyledBuyitNow
                    style={{ color: "black", backgroundColor: "lightgrey" }}
                  >
                    {t("common:newCommanTrans:buyNow")}
                  </StyledBuyitNow>
                ) : (
                  <StyledBuyitNow
                    onClick={() => {
                      setCurrentProductData(val);
                    }}
                  >
                    {t("common:newCommanTrans:buyNow")}
                  </StyledBuyitNow>
                )}
              </StyledBtnContainer>
            </div>
          );
        },
      },
    },
    {
      name: "",
      label: `${t("common:Tender:tableColumnNames:action")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          let val: any = auctionProducts[rowIndex];
          return (
            <div
              style={{
                display: "flex",
                gridGap: "10px",
                justifyContent: "center",
              }}
            >
              <div
                title={`Note`}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  openProductDetail(auctionId, val.perId, val.productStartDate)
                }
              >
                <FontAwesomeIcon
                  icon={faEditProps}
                  style={{ color: "#014a99" }}
                />
              </div>
              <div
                title={`Add Product into Wishlist`}
                style={{ cursor: "pointer" }}
              >
                {isReadOnlyUser ? (
                  <FontAwesomeIcon
                    icon={faHeartProps}
                    style={{ color: "gray" }}
                    onClick={() => {
                      renderReadOnlyUserToast(val.sellerAuctionUserId);
                    }}
                  />
                ) : (
                  <>
                    {val.sellerAuctionUserId !== jwlAuctionUserId ? (
                      <>
                        {getWatchedProduct(
                          val.watched,
                          val.perId,
                          auctionId,
                          val.perId
                        )}
                      </>
                    ) : (
                      <FontAwesomeIcon
                        icon={faHeartProps}
                        style={{ color: "gray" }}
                        onClick={() => {
                          renderReadOnlyUserToast(val.sellerAuctionUserId);
                        }}
                      />
                    )}
                  </>
                )}
              </div>
              <div
                title={`Share Product`}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  shareButtonAction(val.perId, val.productStartDate)
                }
              >
                <FontAwesomeIcon
                  icon={faShareSquareProps}
                  style={{ color: "#014a99" }}
                />
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "productEndDate",
      label: `${t("common:Tender:tableColumnNames:timeLeft")}`,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { minWidth: "150px", maxWidth: "150px" },
        }),
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          let val: any = auctionProducts[rowIndex];
          if (val.productExtended !== undefined) {
            if (val.productExtended) {
              return (
                <span style={{ color: "red" }}>
                  {productTimeLeft(val.productEndDate)}
                </span>
              );
            } else {
              return <span>{productTimeLeft(val.productEndDate)}</span>;
            }
          }
        },
      },
    },
    {
      name: "code",
      label: `SKU`,
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          let val: any = auctionProducts[rowIndex];
          return (
            <span
              className="linkCss"
              onClick={() =>
                openProductDetail(auctionId, val.perId, val.productStartDate)
              }
              onContextMenu={(event: any) =>
                rightClickEvent(event, val.perId, val.productStartDate)
              }
            >
              {val.code}
            </span>
          );
        },
      },
    },
    {
      name: "lab",
      label: `${t("common:Tender:tableColumnNames:lab")}`,
      options: {
        filter: false,
        sort: true,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          let val: any = auctionProducts[rowIndex];
          if (
            val.lab !== "AGT" &&
            val.lab !== "agt" &&
            val.lab !== "" &&
            val.lab !== undefined
          ) {
            return (
              <span
                className="linkCss"
                onClick={() =>
                  openJewelleryCertificateLinkPopup(val.lab, val.certificate)
                }
              >
                {val.lab}
              </span>
            );
          } else {
            return <span>{val.lab}</span>;
          }
        },
      },
    },
    {
      name: "certificate",
      label: `${t("common:Tender:tableColumnNames:certification")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "jewelleryDetails",
      label: `${t("common:Tender:tableColumnNames:description")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          let val: any = auctionProducts[rowIndex];
          return (
            <EllipsisText
              text={getDescription(val.jewelleryDetails)}
              length={70}
              tail={"..."}
            />
          );
        },
      },
    },
    {
      name: "currency",
      label: "currency",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "remarks",
      label: `${t("common:Tender:tableColumnNames:remark")}`,
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          let val: any = auctionProducts[rowIndex];
          return (
            <EllipsisText
              text={getRemarks(val.remarks)}
              length={30}
              tail={"..."}
            />
          );
        },
      },
    },
    {
      name: "notes",
      label: `${t("common:Tender:tableColumnNames:notes")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "caratMinimumPrice",
      label: `${t("common:Tender:tableColumnNames:jewelleryPrice")}`,
      options: {
        filter: false,
        sort: true,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          let val: any = auctionProducts[rowIndex];
          return (
            <div>
              {convertedValue(
                val.currency,
                val.caratMinimumPrice,
                val.exchangeRates[0].rate
              )}
            </div>
          );
        },
      },
    },
    {
      name: "myLatestBid",
      label: `${t("common:Tender:tableColumnNames:placeBid")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          let val: any = auctionProducts[rowIndex];
          return (
            <>
              {isDataRefresh ? (
                <div>
                  {val.myLatestBid === undefined || val.myLatestBid === null
                    ? 0
                    : handelMyBidsLabel(
                      myLatestBidForProduct,
                      val.perId,
                      val.currency,
                      val.exchangeRates[0].rate
                    )}
                </div>
              ) : (
                <div>
                  {val.myLatestBid === undefined || val.myLatestBid === null
                    ? 0
                    : handelMyBidsLabel(
                      myLatestBidForProduct,
                      val.perId,
                      val.currency,
                      val.exchangeRates[0].rate
                    )}
                </div>
              )}
              {getBidNowButtonDisable(
                val.sellerAuctionUserId,
                jwlAuctionUserId,
                val.auctionUserId,
                auctionProducts[rowIndex],
                getReturnMyLatestStoredBid(myLatestBidForProduct, val.perId),
                val.currentBidPrice,
                val.perId,
                val.previousHighestBidder,
                val.holdPreviousBidder,
                rowIndex
              )}
            </>
          );
        },
      },
    },
    {
      name: "currentBidPrice",
      label: `${t("common:Tender:tableColumnNames:liveHighestBid")}`,
      options: {
        filter: true,
        sort: true,
        display: true,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          let val: any = auctionProducts[rowIndex];
          return (
            <div>
              {convertedValue(
                val.currency,
                val.currentBidPrice,
                val.exchangeRates[0].rate
              )}
            </div>
          );
        },
      },
    },
    {
      name: "noOfBidders",
      label: `${t("common:Tender:tableColumnNames:noOfBiddersOrBids")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          let val: any = auctionProducts[rowIndex];
          return (
            <div>
              {getNoOfBiddersAndNoOfBids(val.noOfBidders, val.noOfBids)}
            </div>
          );
        },
      },
    },
    {
      name: "rowColor",
      label: "Bid Color",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "exchangeRates",
      label: "Exchange Rate",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "myLatestBid",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "currentBidPrice",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "noOfBids",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "watched",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "sellerAuctionUserId",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "tenderSecondHighestBid",
      label: `${t("common:Tender:tableColumnNames:liveHighestBid")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "previousHighestBidder",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "productStartDate",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "productExtended",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "holdPreviousBidder",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
  ];

  //get bid now button disable
  const getBidNowButtonDisable = (
    sellerId: any,
    auctionUserIdForProduct: any,
    tableAuctionUserId: any,
    tableDataForUIBox: any,
    myBidsForProduct: any,
    currentBidPriceForProduct: any,
    currentproductId: any,
    previousBidderId: any,
    holdPreviousBidder: any,
    indexVal: any
  ) => {
    renderAutomaticBidPopup(tableDataForUIBox);
    if (isReadOnlyUser) {
      return (
        <StyledBtnContainer
          onClick={() => {
            renderReadOnlyUserToast(sellerId);
          }}
        >
          <StyledButtonGray>
            {t("common:inquiry:button:bidNow")}
          </StyledButtonGray>
        </StyledBtnContainer>
      );
    } else {
      if (sellerId === auctionUserIdForProduct) {
        return (
          <StyledBtnContainer
            onClick={() => {
              renderReadOnlyUserToast(sellerId);
            }}
          >
            <StyledButtonGray>
              {t("common:inquiry:button:bidNow")}
            </StyledButtonGray>
          </StyledBtnContainer>
        );
      } else {
        return (
          <StyledBtnContainer>
            <StyledButton
              onClick={() => handleBidClick(tableDataForUIBox, indexVal)}
            >
              {t("common:inquiry:button:bidNow")}
            </StyledButton>
          </StyledBtnContainer>
        );
      }
    }
  };
  //get My All MyBid
  const handelMyBidsLabel = (
    myStoredBids: any,
    currentProductId: any,
    currency: any,
    exchangeRate: any
  ) => {
    const Obj = myLatestBidForProduct.filter(
      (item: any) => item.productId === currentProductId
    );
    const mybidPriceforProduct = Obj.map((item: any, index: number) => {
      return item.productId;
    });

    return getMyLatestStoredBids(
      myLatestBidForProduct,
      currentProductId,
      currency,
      exchangeRate,
      mybidPriceforProduct
    );
  };

  const shareButtonAction = (perId: any, productStartDate: any) => {
    const { t } = props;
    date = productStartDate.split(" ", 2);
    let languageCode =
      localStorage.getItem("language") === "EN"
        ? "en"
        : localStorage.getItem("language") === "zh_CN"
          ? "zh_CN"
          : "jp";
    copy(
      `${window.location.hostname}/${languageCode}/product/jewellery/${perId}/${date[0]}/detail`
    );
    setAlertType("success");
    setOpenToast(true);
    setShowAlertMessage(`${t("common:preview:linkCopied")}`);
    setTimeout(() => {
      setOpenToast(false);
    }, 2000);
  };

  const getNoOfBiddersAndNoOfBids = (noOfBidders: any, noOfBids: any) => {
    return `${noOfBidders}/${noOfBids}`;
  };

  const getRemarks = (remarks: any) => {
    if (remarks !== "" && remarks !== undefined && remarks !== null) {
      return remarks;
    } else {
      return "";
    }
  };

  const getDescription = (jewelleryDetails: any) => {
    var jewelleryType: string = "";
    var jewelleryCondition: string = "";
    var jewelleryDescription: string = "";
    if (jewelleryDetails !== undefined && jewelleryDetails !== null) {
      if (
        jewelleryDetails.jewelleryType !== undefined &&
        jewelleryDetails.jewelleryType !== null
      ) {
        jewelleryType = jewelleryDetails.jewelleryType;
      } else {
        jewelleryType = "";
      }

      if (
        jewelleryDetails.jewelleryCondition !== undefined &&
        jewelleryDetails.jewelleryCondition !== null
      ) {
        jewelleryCondition = jewelleryDetails.jewelleryCondition;
      } else {
        jewelleryCondition = "";
      }

      if (
        jewelleryDetails.jewelleryDescription !== undefined &&
        jewelleryDetails.jewelleryDescription !== null
      ) {
        jewelleryDescription = jewelleryDetails.jewelleryDescription;
      } else {
        jewelleryDescription = "";
      }
    }

    return (
      jewelleryType + " " + jewelleryCondition + " " + jewelleryDescription
    );
  };

  const closeModal = () => {
    Auth.logout();
    props.history.replace("/");
  };

  const handleBtnValue = (
    values: number,
    currentBidPrice: any,
    productId: any,
    myBidValues: any,
    productIndexsValue: any,
    watched: boolean
  ) => {
    bidProductIndex = [productIndexsValue];

    var data = [
      {
        bidIncreasedBy: values,
        bidPrice: currentBidPrice,
        auctionUserId: jwlAuctionUserId,
        auctionId: auctionId,
        productId: productId,
        watched: watched
      },
    ];
    var dataProduct = [productId];
    let updateRowIndex: any = myLatestBidForProduct.findIndex(
      (product: any) => product.productId === myBidValues.productId
    );
    if (updateRowIndex === -1) {
      var myLatestBidForProductObjectData: any = [
        ...myLatestBidForProduct,
        myBidValues,
      ];
      myLatestBidForProduct = myLatestBidForProductObjectData;
    } else {
      var updatedArray = update(myLatestBidForProduct, {
        $splice: [[updateRowIndex, 1, myBidValues]],
      });
      myLatestBidForProduct = updatedArray;
    }
    bidProduct(data, dataProduct);
  };

  const bulkBidHandler = (
    values: any[],
    myBidBulkValues: any,
    productids: any,
    productIndexsValue: any
  ) => {
    bidProductIndex = productIndexsValue;
    myLatestBidForProduct = myBidBulkValues;
    let obj: any = productids;
    watchedItemArr.current = values;
    //bid publish
    bidProduct(values, obj);
    onGridSelectionChange(0);
    PubSub.publish("resetAnnualGridBoxIndex", []);
    dispatch(resetGridProductAllProductIndexes());
    dispatch(resetjewelleryAllProductSelectAll());
    setIsSelected(false);
  };

  const bidProduct = (payloadBid: any, productObj: any) => {
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.postRequest(
        annualBidUrl,
        payloadBid,
        (status: any, response: any) => {
          if (status === 200) {
            getMyRecentBids(auctionId, productObj);
            let isBidIncreasedBy = payloadBid.some((obj: any) => obj.hasOwnProperty("bidIncreasedBy"));

            if (!isBidIncreasedBy) {
              bulkPrebidCallingApi(payloadBid);
            }
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setOnAction(false);
          } else if (status === 404) {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(`${t("common:invalidRequest")}`);
            setAlertType("error");
            setOpenToast(true);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
          }
        }
      );
    }
  };

  const bulkPrebidCallingApi = async (bidobjectarray: any) => {
    const newArr: any = await auctionProducts.map((obj: any) => {
      const bidObj = bidobjectarray.find((bid: any) => bid.productId === obj.perId);
      if (bidObj) {
        return {
          ...obj,
          watched: bidObj.watched,
        };
      }
      return obj;
    });
    setAuctionProducts(() => ([...newArr]));
  };

  const tabItemClick = (value: any) => {
    if (value === "1") {
      setTabValue({
        allProducts: true,
        myBids: false,
      });
      dispatch(reSetJwlIsMybids());
    } else {
      setTabValue({
        allProducts: false,
        myBids: true,
      });
    }
  };

  const filteredAuction = async (
    auctions: any,
    isFilter: boolean,
    values: any,
    isCustomFilter?: any
  ) => {
    localStorage.removeItem("currentStart");
    if (
      localStorage.getItem("annualdropDownFilterVal") !== undefined &&
      localStorage.getItem("annualdropDownFilterVal") !== null
    ) {
      var tempArr = localStorage.getItem("annualdropDownFilterVal");
      if (tempArr !== null) var dropDownValues = JSON.parse(tempArr);
      var property = dropDownValues[0].property;
      var direction = dropDownValues[0].direction;
    }

    if (values === null) {
      filter = null;
      payload = {
        page: {
          start: 0,
          count: endCount,
          sort: {
            orders: [
              {
                property:
                  property !== null && property !== undefined
                    ? property
                    : "productEndDate",
                direction:
                  direction !== null && direction !== undefined
                    ? direction
                    : "ASC",
              },
            ],
          },
        },
      };
    } else {
      body = [];
      values.map((item: any, index: number) => {
        if (item.name === "auctionId") {
          values.splice(index, 1);
        }
      });
      values.push({
        match: "exact",
        name: "parcelType",
        value: "Jewellery",
      });
      body = values;
      payload = {
        filters: {
          or: [],
          and: body,
        },
        page: {
          start: 0,
          count: endCount,
          sort: {
            orders: [
              {
                property:
                  property !== null && property !== undefined
                    ? property
                    : "productEndDate",
                direction:
                  direction !== null && direction !== undefined
                    ? direction
                    : "ASC",
              },
            ],
          },
        },
      };
      if (isCustomFilter === undefined) {
        filter = body;
        localStorage.setItem("filteredJewelleryValues", JSON.stringify(body));
      }
    }
    await filterCAllback(payload);
  };

  const filterCAllback = (dataVal: any) => {
    if (selectcurrentApiStartCountValue === 0) {
      callApi(dataVal);
    } else {
      dispatch(resetAnnualJewelleryCurrentApiStartCount());
    }
  };

  const renderer = ({
    formatted: { days, hours, minutes, seconds },
    completed,
  }: any) => {
    if (completed) {
      if (
        days === "00" &&
        hours === "00" &&
        minutes === "00" &&
        seconds === "00"
      ) {
        getExtendedTime();
        return <span>00:00:00:00</span>;
      }
    } else {
      return (
        <span>
          {days}:{hours}:{minutes}:{seconds}
        </span>
      );
    }
  };

  const getExtendedTime = () => {
    if (!countAnnualRef.current) {
      if (secondTryAnnualRef.current === 0) {
        getTendorAucProducts(auctionId, selectcurrentApiStartCountValue);
      } else {
        getTendorAucProductsFirst(auctionId, selectcurrentApiStartCountValue);
      }
      countAnnualRef.current = countAnnualRef.current + 1;
    }
    closebidPopup();
  };

  const getExtendedTimeGrid = (pagenum: any) => {
    if (!countAnnualRef.current) {
      if (secondTryAnnualRef.current === 0) {
        getTendorAucProducts(auctionId, pagenum);
      } else {
        getTendorAucProductsFirst(auctionId, pagenum);
      }
      countAnnualRef.current = countAnnualRef.current + 1;
    }
    closebidPopup();
  };

  const productTimeLeft = (startDate: any) => {
    let date: string | null = "";
    let time: string | null = "";
    let timezone: any = "";

    if (startDate !== null || startDate !== undefined) {
      let previewTime = moment.utc(startDate);
      if (timezone !== null) {
        timezone = localStorage.getItem("timezoneName");
      }
      if (previewTime !== null || previewTime !== undefined) {
        let result = moment.tz(previewTime, timezone);
        let resultFormatter = result.format();
        if (resultFormatter !== "Invalid date") {
          let splitDateTime = resultFormatter.split("T", 2);
          let splitTime: any = "";
          if (splitDateTime[1].includes("+")) {
            splitTime = splitDateTime[1].split("+", 2);
          } else {
            splitTime = splitDateTime[1].split("-", 2);
          }
          date = splitDateTime[0];
          time = splitTime[0];
          let dateTime = `${date} ${time}`;
          let end: any = moment(dateTime);
          timezone = localStorage.getItem("timezoneName");
          let start: any = moment(
            new Date().toLocaleString("en-US", { timeZone: timezone })
          );
          var timeDiff = end - start;
          seconds = Math.round(timeDiff);
        }
      }
    }
    return (
      <Countdown
        date={Date.now() + seconds}
        className="countdownText"
        renderer={renderer}
        zeroPadTime={2}
      />
    );
  };

  const setItemsPerPageHandler = (itemsPerPage: number) => {
    localStorage.setItem("jwlcurrentPageOfTenderAllProducts", "0");
    setCurrentPage(1);
    setItemsPerPage(itemsPerPage);
    jwlItemPerPageRef.current = itemsPerPage;
    dispatch(setAnnualJewelleryItemPerPage({ itemsPerPage }));
    dispatch(resetAnnualJewelleryCurrentApiStartCount());
  };

  function setCurrentPage(currentPage: number) {
    return currentPage;
  }

  function setItemsPerPage(itemsPerPage: number) {
    return itemPerPage(true, 0, itemsPerPage);
  }

  const itemPerPage = (value: boolean, start: number, itemPerPage: number) => {
    if (value === true) {
      localStorage.setItem("annualitemsPerPage", JSON.stringify(itemPerPage));
      getUpdatedProducts(value, start, itemPerPage);
    }
  };

  const getUpdatedProducts = (value: any, start: any, endRecords: any) => {
    if (value === true) {
      getProducts(start, endRecords);
    }
  };

  const getProducts = (start: number, itemsPerPage: number) => {
    startCount = start;
    endCount = itemsPerPage;
    localStorage.setItem("currentStart", JSON.stringify(start));
    let currentPage = start / itemsPerPage;

    dispatch(setAnnualJewelleryCurrentApiStartCount({ currentPage }));
    dispatch(setAnnualJewelleryItemPerPage({ itemsPerPage }));
    PubSub.publish("resetAnnualGridBoxIndex", []);
    dispatch(resetGridProductAllProductIndexes());
    dispatch(resetjewelleryAllProductSelectAll());
    onGridSelectionChange(0);
    setIsLoading(true);
    if (currentPage === selectcurrentApiStartCountValue) {
      setIsLoading(false);
    }
  };

  const theme = useTheme();
  const notSmallDevices = useMediaQuery(theme.breakpoints.between("md", "xl"));
  let isAuctionPage: any = true;
  let isCategoryPageType: any = false;

  const handleMyBids = (auctionsProduct: any) => {
    if (auctionsProduct.length > 0) {
      setAuctionProducts(auctionsProduct);
    }
  };

  const addToWatchList = (
    productId: string | number,
    auctionId: string | number
  ) => {
    setOnAction(true);
    setOpenToast(false);
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.postRequest(
        `${productUrl}/${auctionId}/${productId}/watch`,
        "payload",
        (status: any, response: any) => {
          if (response !== undefined) {
            if (status === 200) {
              const newArr: any = auctionProducts.map((obj: any) => {
                if (obj.perId === productId) {
                  return {
                    ...obj,
                    watched: true,
                  };
                }
                return obj;
              });
              auctionProductResult = newArr;
              setAuctionProducts(() => newArr);
              setIsTableExpanded(false);
              setIsLoading(false);
              setOnAction(false);
              setShowAlertMessage(`${t("common:preview:addedToWatchMsg")}`);
              setAlertType("success");
              setOpenToast(true);
            }
          }
        }
      );
    }
  };

  //get Watched Product
  const getWatchedProduct = (
    watched: any,
    productId: any,
    auctionId: any,
    serialNo: any
  ) => {
    if (watched === true) {
      return (
        <FontAwesomeIcon
          icon={faHeartProps}
          style={{ color: "red", cursor: "pointer" }}
          onClick={() => removeFromWatchlist(productId, auctionId)}
        />
      );
    } else {
      return (
        <FontAwesomeIcon
          icon={faHeartProps}
          style={{ color: "gray" }}
          onClick={() => addToWatchList(productId, auctionId)}
        />
      );
    }
  };

  const removeFromWatchlist = (
    productId: string | number,
    auctionId: string | number
  ) => {
    setOnAction(true);
    setOpenToast(false);
    if (Auth.loggedIn() === null) {
      props.history.push("/");
    } else {
      Auth.postRequest(
        `${productUrl}/${auctionId}/${productId}/unwatch`,
        "payload",
        (status: any, response: any) => {
          if (status === 200) {
            const newArr: any = auctionProducts.map((obj: any) => {
              if (obj.perId === productId) {
                return {
                  ...obj,
                  watched: false,
                };
              }
              return obj;
            });
            auctionProductResult = newArr;
            setAuctionProducts(() => newArr);
            setIsTableExpanded(false);
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response.data.message);
            setAlertType("success");
            setOpenToast(true);
          }
        }
      );
    }
  };

  const mypageRedirection = () => {
    localStorage.removeItem("selectedFilterSort");
    date = auctionDate.split(" ", 2);
    props.history.push("/my-page");
    dispatch(resetAnnualJewelleryItemPerPage());
    dispatch(resetAnnualJewelleryCurrentApiStartCount());
    PubSub.publish("resetAnnualGridBoxIndex", []);
  };

  const openProductDetail = (
    auctionId: string,
    perId: string,
    productStartDate: string
  ) => {
    date = productStartDate.split(" ", 2);
    props.history.push(
      `/365products/details/${auctionId}/${jwlAuctionUserId}/${perId}/${date[0]}/${isMypage}?auctionType=Jewellery`
    );
    PubSub.publish("resetAnnualGridBoxIndex", []);
  };
  const openDetailsView = (
    auctionId: string,
    perId: string,
    productStartDate: string
  ) => {
    date = productStartDate.split(" ", 2);
    window.open(
      `/365products/details/${auctionId}/${jwlAuctionUserId}/${perId}/${date[0]}/${isMypage}?auctionType=Jewellery`,
      "_blank"
    );
    PubSub.publish("resetAnnualGridBoxIndex", []);
  };

  const rightClickEvent = (
    event: React.MouseEvent<HTMLDivElement>,
    productId: string,
    productStartDate: string
  ) => {
    event.preventDefault();
    setMouseState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
    setCurrentProductId(productId);
    setProductStartDate(productStartDate);
  };

  const handleClose = () => {
    setMouseState(initialState);
  };

  const listGridview = () => {
    onGridSelectionChange(0);
    PubSub.publish("resetAnnualGridBoxIndex", []);
    selectJwlPageUseRef.current = startCount;
    setUiBoxView(true);
    dispatch(setJwlIsGridView({ gridView: true }));
  };

  const Gridview = () => {
    onGridSelectionChange(0);
    PubSub.publish("resetAnnualGridBoxIndex", []);
    setUiBoxView(false);
    dispatch(resetJwlIsGridView());
  };

  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  const renderReadOnlyUserToast = async (id: any) => {
    var joinedAuctions: any = localStorage.getItem("joinedAnnualAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);
    if (joinedAuctions !== null) {
      joinedAuctions.filter((items: any, index: number) => {
        if (items.category === "Jewellery") {
          if (id === items.auctionUserId) {
            isAuctionUserId = true;
          }
        }
      });
    } else {
      isAuctionUserId = false;
    }
    await renderPopup();
  };

  const renderPopup = () => {
    if (isReadOnlyUser) {
      setOpenReadOnlyUserToast(true);
    } else if (isAuctionUserId) {
      setOpenReadOnlyUserToast(true);
    } else {
      setOpenReadOnlyUserToast(false);
    }
    setTimeout(() => {
      setOpenReadOnlyUserToast(false);
    }, 3000);
  };

  const isSticky = (e: any) => {
    const header: any = document.querySelector(".AccordionHeader");
    const scrollTop = window.scrollY;
    const className =
      scrollTop >= 10
        ? header?.classList.add("AccordionHeaderscroll")
        : header?.classList.remove("AccordionHeaderscroll");
  };

  useEffect(() => {
    let isShowDrawerIcon: any = localStorage.getItem("isShowDrawerIcon");
    isShowDrawerIcon = JSON.parse(isShowDrawerIcon);
    if (isShowDrawerIcon !== null) {
      if (isShowDrawerIcon) {
        const accordionHeader: any = document.querySelector(".AccordionHeader");
        if (accordionHeader !== null) {
          accordionHeader.style.width = isShowDrawerIcon
            ? "calc(100% - 60px)"
            : "calc(100% - 240px)";
        }
      }
    }
  });

  const closebidPopup = () => {
    setshowTenderSlider(false);
    setShowBulkBidPopup(false);
    // PubSub.publish("resetAnnualGridBoxIndex", []);
  };

  const productCart = () => {
    localStorage.removeItem("selectedFilterSort");
    props.history.push(`/productCart/${auctionId}/Jewellery`);
    dispatch(resetAnnualJewelleryItemPerPage());
    dispatch(resetAnnualJewelleryCurrentApiStartCount());
  };

  const exportExcel = () => {
    setIsExportDisable(true);
    let exportProductIds = auctionProducts.slice(0, 1).map((item: any) => {
      return item.auctionId;
    });
    Auth.postRequestForExcel(
      `${productDownload}?auctionId=${exportProductIds}&auctionType=Annual`,
      { ids: "" },
      (status: any, response: any) => {
        if (status === 200) {
          if (response !== undefined) {
            const url = window.URL.createObjectURL(
              new Blob([response], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Products.xlsx`);
            document.body.appendChild(link);
            link.click();
          }
        } else {
          //todo
        }
      }
    );
    setTimeout(() => {
      setIsExportDisable(false);
    }, 5000);
  };

  const selectAllInGridView = () => {
    //calling select all function in grid View
    let arr: any = [];
    if (!isReadOnlyUser) {
      auctionProducts.map((productVal: any, index: any) => {
        if (arr.length < 10) {
          if (productVal.sellerAuctionUserId === jwlAuctionUserId) {
            // Do something if current user is the seller
          } else {
            arr = [...arr, index];
          }
        }
      });
    } else {
      setShowAlertMessage(`You are the read only user.`);
      setAlertType("error");
      setOpenToast(true);
      setTimeout(() => {
        setOpenToast(false);
      }, 3000);
    }

    if (isSelected) {
      setIsSelected(false);
      PubSub.publish("resetAnnualGridBoxIndex", []);
      arr = [];
      dispatch(resetGridProductAllProductIndexes());
      dispatch(resetjewelleryAllProductSelectAll());
    } else {
      setIsSelected(true);
      dispatch(setGridProductAllProductIndexes({ indexes: arr }));
      dispatch(setjewelleryAllProductSelectAll({ isSelected: true }));
    }
  };


  const onBuyItNowPopupHandler = (itemArr: any) => {
    setCurrentProductData(itemArr);
    // openedBuyItNowPopupID.current = itemArr;
  }

  // buy it now button condition
  useEffect(() => {
    if (currentProductData !== null) {
      setIsBuyItNowModal(true);
    }
  }, [!currentProductData]);

  const renderBuyItNowConfirmationModal = () => {
    return (
      <StyledModal
        open={isBuyItNowModal}
        onClose={() => {
          setCurrentProductData(null);
          setIsBuyItNowModal(false);
        }}
      >
        <BuyItNowconfirmation
          closeModal={() => {
            setCurrentProductData(null);
            setIsBuyItNowModal(false);
          }}
          itemDetails={currentProductData}
          auctionUserId={jwlAuctionUserId}
        />
      </StyledModal>
    );
  };

  const renderWinnerModal = () => {
    return (
      <StyledModal open={buyItWinnerPop}>
        <ViewBuyItNowWinnerModal
          closeModal={() => {
            setBuyItWinnerPop(false);
            setProductDetails("");
          }}
          name={productDetails}
        />
      </StyledModal>
    );
  };

  const bulkWatchlistHandler = () => {
    if (!isReadOnlyUser) {
      if (indexsForBulkBidItems.length > 0) {
        setShowBulkBidPopup(true);
      } else {
        setShowAlertMessage(`Please Select Product to watch.`);
        setAlertType("error");
        setOpenToast(true);
        setTimeout(() => {
          setOpenToast(false);
        }, 2000);
      }
    } else {
      setShowAlertMessage(`You are the read only user.`);
      setAlertType("error");
      setOpenToast(true);
      setTimeout(() => {
        setOpenToast(false);
      }, 3000);
    }
  };

  return (
    <Grid>
      {apiTimeout === true ? (
        <ApiTimeout {...props} t={t} />
      ) : (
        <>
          {isLoading === true ? (
            <div className="loader">
              <LoadingSpinner />
            </div>
          ) : (
            <StyledLayoutGridMain>
              {tabValue.allProducts ? (
                <StyledBoxContent title="Click here for advance search">
                  <StyledDropDown
                    src="/images/assets/doubledown.png"
                    alt="d"
                    style={{
                      transform: isFiltersOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                    onClick={handleFilters}
                  />
                </StyledBoxContent>
              ) : null}

              {tabValue.allProducts ? (
                <>
                  {isFiltersOpen && (
                    <div
                      style={{
                        marginTop: "10px",
                      }}
                    >
                      <JewelleryFilter
                        {...props}
                        t={t}
                        filterJewelleryAuction={filteredAuction}
                        auctionId={auctionId}
                        annualAuction={true}
                        isPreviewPage={false}
                      />
                    </div>
                  )}
                </>
              ) : null}

              {/* <Grid item={true} xs={12}>
                <Grid
                  container={true}
                  spacing={0}
                  className="actionContainer"
                  style={{
                    padding: "20px 0px 0 8px",
                    justifyContent: "center",
                  }}
                >
                  <Grid item xs={12} sm={12} md={12} lg={4} xl={3}>
                    <StyledTabLayout container spacing={0}>
                      <StyledContent item xs={12}>
                        <AnnualTabJwl
                          {...props}
                          t={t}
                          tabClick={tabItemClick}
                        />
                      </StyledContent>
                    </StyledTabLayout>
                  </Grid>
                </Grid>
              </Grid> */}

              {/* {tabValue.allProducts ? ( */}
              <StyledHeaderContainer container={true} spacing={0}>
                <StyledCoreDataGridContainer container={true} spacing={0}>
                  <StyledActionBarContainer
                    container={true}
                    spacing={0}
                    className="coreActionBarContainer"
                  >
                    <StyledContainer>
                      <BasicSearchBox
                        autoCompleteSearch={autoCompleteSearch}
                        textSearchListing={textSearchListing}
                        setTextSearchArray={setTextSearchArray}
                      />
                    </StyledContainer>
                    <StyledContainer>
                      {notSmallDevices ? (
                        <>
                          {isGridView === true ? (
                            <StyledSelectAllButtonHeader
                              onClick={selectAllInGridView}
                            >
                              {t("common:newCommanTrans:selectAll")}
                            </StyledSelectAllButtonHeader>
                          ) : null}
                        </>
                      ) : (
                        <StyledSelectAllButtonHeader
                          onClick={selectAllInGridView}
                        >
                          {t("common:newCommanTrans:selectAll")}
                        </StyledSelectAllButtonHeader>
                      )}

                      <StyledButtonHeader onClick={() => mypageRedirection()}>
                        {t("common:newCommanTrans:myPage")}
                      </StyledButtonHeader>

                      <JewelleryAnnualActionPage
                        setItemsPerPageHandler={setItemsPerPageHandler}
                        t={t}
                      />

                      <StyledButtonHeader onClick={productCart}>
                        {t("common:newCommanTrans:Cart")}
                      </StyledButtonHeader>

                      {isExportDisable ? (
                        <StyledIconImg
                          src="/images/assets/iconDownload.png"
                          alt="exportsheet"
                          title="Download Export"
                        />
                      ) : (
                        <StyledIconImg
                          src="/images/assets/iconDownload.png"
                          alt="exportsheet"
                          title="Download Export"
                          onClick={exportExcel}
                        />
                      )}
                    </StyledContainer>
                    <StyledContainer>
                      {/* <StyledIconImg
                        src="/images/assets/bidIcon.png"
                        alt="bidIcon"
                        title="Select items to bulk prebid or watchlist"
                        onClick={bulkWatchlistHandler}
                      /> */}
                      {notSmallDevices ? (
                        <>
                          <StyledContainer>
                            {isGridView ? (
                              <StyledIconImg
                                src="/images/assets/listViewIcon.png"
                                onClick={Gridview}
                                className="icon"
                                title="List view of Product"
                              />
                            ) : (
                              <StyledIconImg
                                src="/images/assets/gridViewIcon.png"
                                onClick={listGridview}
                                title="Grid view of Product"
                                className="icon"
                              />
                            )}
                          </StyledContainer>
                        </>
                      ) : null}
                    </StyledContainer>
                  </StyledActionBarContainer>
                </StyledCoreDataGridContainer>
              </StyledHeaderContainer>
              {/* ) : null} */}

              <StyledLayoutGrid container={true}>
                {/* {tabValue.allProducts === true ? ( */}
                <>
                  {isGridView === false && notSmallDevices && (
                    <MuiThemeProvider theme={getMuiTheme()}>
                      <MUIDataTable
                        title={""}
                        data={auctionProducts}
                        columns={columns}
                        options={options}
                      />
                    </MuiThemeProvider>
                  )}

                  {isGridView === true ? (
                    notSmallDevices && (
                      <>
                        <JwlProductGridDataParent
                          t={t}
                          data={auctionProducts}
                          totalElements={totalElement}
                          itemPerPage={itemPerPage}
                          value={getUpdatedProducts}
                          noProductFound={handleMyBids}
                          jwlItemPerPageRef={selectItemPerPageValue}
                          selectJwlPageUseRef={selectJwlPageUseRef.current}
                        >
                          {auctionProducts.length > 0 ? (
                            <ProductGridDataChildComponent
                              {...props}
                              watchlist={addToWatchList}
                              unWatchlist={removeFromWatchlist}
                              setShowBidPopupBidModal={getBoxIndex}
                              auctionName={auctionName}
                              auctionDate={date[0]}
                              t={t}
                              isAuctionPage={isAuctionPage}
                              isCategoryPageType={isCategoryPageType}
                              auctionUserId={jwlAuctionUserId}
                              boxColor={boxColor}
                              sortingValue={filterSort}
                              bulkBidIndexHandler={onGridSelectionChange}
                              myForProductAllProduct={myLatestBidForProduct}
                              renderAutomaticBidPopupInMobile={
                                renderAutomaticBidPopupInMobile
                              }
                              renderReadOnlyUserToast={
                                renderReadOnlyUserToast
                              }
                              isRefreshData={getExtendedTimeGrid}
                              rightClickEvent={rightClickEvent}
                            />
                          ) : (
                            <Grid container={true} spacing={0}>
                              <StyledTextWrapper item xs={12}>
                                {t("common:preview:noProductFound")}
                              </StyledTextWrapper>
                            </Grid>
                          )}
                        </JwlProductGridDataParent>
                      </>
                    )
                  ) : (
                    <></>
                  )}

                  {notSmallDevices || (
                    <>
                      <JwlProductGridDataParent
                        t={t}
                        data={auctionProducts}
                        totalElements={totalElement}
                        itemPerPage={itemPerPage}
                        value={getUpdatedProducts}
                        noProductFound={handleMyBids}
                        jwlItemPerPageRef={selectItemPerPageValue}
                        selectJwlPageUseRef={selectJwlPageUseRef.current}
                      >
                        {auctionProducts.length > 0 ? (
                          <ProductGridDataChildComponent
                            {...props}
                            watchlist={addToWatchList}
                            unWatchlist={removeFromWatchlist}
                            setShowBidPopupBidModal={getBoxIndex}
                            auctionName={auctionName}
                            auctionDate={date[0]}
                            t={t}
                            isAuctionPage={isAuctionPage}
                            isCategoryPageType={isCategoryPageType}
                            auctionUserId={jwlAuctionUserId}
                            sortingValue={filterSort}
                            boxColor={boxColor}
                            bulkBidIndexHandler={onGridSelectionChange}
                            myForProductAllProduct={myLatestBidForProduct}
                            renderAutomaticBidPopupInMobile={
                              renderAutomaticBidPopupInMobile
                            }
                            renderReadOnlyUserToast={renderReadOnlyUserToast}
                            isRefreshData={getExtendedTimeGrid}
                            rightClickEvent={rightClickEvent}
                          />
                        ) : (
                          <Grid container={true} spacing={0}>
                            <StyledTextWrapper item xs={12}>
                              {t("common:preview:noProductFound")}
                            </StyledTextWrapper>
                          </Grid>
                        )}
                      </JwlProductGridDataParent>
                    </>
                  )}
                </>
                <BulkBidFloatingIcon handleClick={bulkWatchlistHandler} />
                <Menu
                  keepMounted
                  open={mouseState.mouseY !== null}
                  onClose={handleClose}
                  anchorReference="anchorPosition"
                  anchorPosition={
                    mouseState.mouseY !== null && mouseState.mouseX !== null
                      ? { top: mouseState.mouseY, left: mouseState.mouseX }
                      : undefined
                  }
                >
                  <MenuItem
                    onClick={() =>
                      openDetailsView(auctionId, currentProductId, productdate)
                    }
                  >
                    Details
                  </MenuItem>
                </Menu>
                {onAction === true && (
                  <div className="loading">
                    <LoadingSpinner />
                  </div>
                )}

                {userBlock && (
                  <StyledModal open={userBlock}>
                    <BlockUserModal t={t} {...props} closeModal={closeModal} />
                  </StyledModal>
                )}

                {openReadOnlyUserToast && (
                  <AlertReadOnlyUser
                    isReadOnlyUser={isReadOnlyUser}
                    isSeller={isAuctionUserId}
                  />
                )}
                {showTenderSlider && (
                  <StyledModal open={showTenderSlider} onClose={closebidPopup}>
                    <ProductBiddingUi
                      t={t}
                      {...props}
                      items={auctionProducts}
                      currentIndex={details}
                      PopupClose={closebidPopup}
                      handleBtnValue={handleBtnValue}
                      auctionDate={date[0]}
                      totalElements={totalElement}
                      endCount={endCount}
                      auctionUserId={jwlAuctionUserId}
                      length={length}
                      boxColor={boxColor}
                      watchedFunction={addToWatchList}
                      unwatched={removeFromWatchlist}
                      myLatestBidForProduct={myLatestBidForProduct}
                      onBuyItNowPopupHandler={onBuyItNowPopupHandler}
                    />
                  </StyledModal>
                )}
                {showBulkBidPopup && (
                  <StyledModal open={showBulkBidPopup} onClose={closebidPopup}>
                    <AnnualBidPopup
                      {...props}
                      items={auctionProducts}
                      popupClose={closebidPopup}
                      handleBtnValue={bulkBidHandler}
                      auctionUserId={jwlAuctionUserId}
                      length={length}
                      productIndexs={indexsForBulkBidItems}
                      myLatestBidForProducts={myLatestBidForProduct}
                      isJewellery={true}
                    />
                  </StyledModal>
                )}
                {isBuyItNowModal &&
                  currentProductData !== null &&
                  renderBuyItNowConfirmationModal()}
                {buyItWinnerPop && renderWinnerModal()}
              </StyledLayoutGrid>
            </StyledLayoutGridMain>
          )}
        </>
      )}
    </Grid>
  );
};

export default JewelleryProductAuction;
